import { render, staticRenderFns } from "./BookMatchRoomUpgrades.vue?vue&type=template&id=e51ce11c&scoped=true&"
import script from "./BookMatchRoomUpgrades.vue?vue&type=script&lang=js&"
export * from "./BookMatchRoomUpgrades.vue?vue&type=script&lang=js&"
import style0 from "./BookMatchRoomUpgrades.vue?vue&type=style&index=0&id=e51ce11c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51ce11c",
  null
  
)

export default component.exports